<div id="hli_UseImageList" #hli_UseImageList class="frame-solid wj-tabpane"
  forcedEnabledMode="true">
  <ul #useImageGroups>
    <li *ngFor="let item of useImageList; let i = index;"
      (mousedown)="eventUseImageList_ITEMCLICK.emit({event: $event, index: i, useImageList: useImageList, useImageGroups: useImageGroups})">
      <app-image-info-renderer1407 [data]="item"></app-image-info-renderer1407>
    </li>
  </ul>
</div>
